import { LAYOUT_LIST, CHART_LINE } from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import { CardHelper } from '~/training/sequence/templates/translators/itemHelpers/CardHelper';
import { ItemOfType } from '~/training/sequence/templates/translators/itemHelpers/types';

export const ChartLine: Translator = sequence => {
  const CardElement = sequence.items?.find(
    item => item.__typename == 'Card'
  ) as ItemOfType<'Card'>;

  return translate(sequence, item => {
    switch (item.__typename) {
      case 'List': {
        return {
          id: item.id,
          type: LAYOUT_LIST,
          values: {
            align: 'center'
          },
          items: [
            CardHelper(CardElement, {
              width: '700px',
              height: 'auto',
              align: 'left',
              extraItems: [
                {
                  type: CHART_LINE,
                  id: '1',
                  values: {
                    title: item.title,
                    subtitle: item.subtitle,
                    items: item.items
                  },
                  items: []
                }
              ]
            })
          ]
        };
      }
      default:
        return null;
    }
  });
};
